import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useAuthStore } from '@/stores/auth';

/**
 * Gate inside the authenticated shell that redirects non-Admin operators
 * away from <c>/operators*</c> back to the tenants list. Per §4.4 / D10:
 * platform-account management is Admin-only, and the menu item is also
 * hidden — this guard catches direct-URL navigation.
 */
export function AdminOnlyRoute({ children }: { children: ReactNode }) {
  const role = useAuthStore((s) => s.operator?.role ?? null);
  if (role !== 'Admin') {
    return <Navigate to="/tenants" replace />;
  }
  return <>{children}</>;
}
